export const BASE_URL = "https://backendone-968d14e99c1c.herokuapp.com";

export const Api ={
    programme:{
        getAllProgrammeList:"/programmeCategory/getAllProgrammeCategoriesForWebsite",
        getCategoryByInProgramme:"/programme/getProgrammesByCategory_id/",
        getProgrammeDetaileById:"/programme/getProgrammeDetailInfo/",
        addProgrammeApplication:"/programmeApplicant/addProgrammeApplicant",
        uploadFile: "/admin/uploadDocument",
    },
    jobs:{
        getAllJobList:"/job/getAllJobs",
        getJobDetailById:"/job/getJobById/",
    },
    auth:{
        userSignUp:"/userWebsite/signup"
    }
}